function stripSystemReminder(message: string): string {
  if (!message) return message;
  let cleaned = message.replace(/<system-reminder>[\s\S]*?<\/system-reminder>/gi, '').trim();
  cleaned = cleaned.replace(/<system-reminder>[\s\S]*$/gi, '').trim();
  return cleaned || message;
}

export function getErrorMessage(error: unknown, fallback = 'An unexpected error occurred'): string {
  if (!error) return fallback;
  if (typeof error === 'string') return stripSystemReminder(error);
  if (error instanceof Error && error.message) return stripSystemReminder(error.message);

  if (typeof error === 'object') {
    const err = error as Record<string, unknown>;
    if (typeof err.message === 'string') return stripSystemReminder(err.message);
    if (typeof err.error === 'string') return stripSystemReminder(err.error);

    const nested = err.error as Record<string, unknown> | undefined;
    if (nested) {
      if (typeof nested.message === 'string') return stripSystemReminder(nested.message);
      if (typeof nested.detail === 'string') return stripSystemReminder(nested.detail);
      if (typeof nested.details === 'string') return stripSystemReminder(nested.details);
      if (Array.isArray(nested.details)) {
        const details = nested.details.filter(item => typeof item === 'string') as string[];
        if (details.length > 0) return stripSystemReminder(details.join(' '));
      }
      if (nested.fields && typeof nested.fields === 'object') {
        const fieldMessages = Object.values(nested.fields as Record<string, unknown>)
          .flatMap(value => Array.isArray(value) ? value : [value])
          .filter(value => typeof value === 'string') as string[];
        if (fieldMessages.length > 0) return stripSystemReminder(fieldMessages.join(' '));
      }
    }

    if (Array.isArray(err.errors)) {
      const messages = err.errors.filter(item => typeof item === 'string') as string[];
      if (messages.length > 0) return stripSystemReminder(messages.join(' '));
    }
  }

  return fallback;
}
